/*
 * @Author: yejinliang
 * @Date: 2021-12-27 16:09:24
 * @LastEditTime: 2021-12-28 15:17:38
 * @LastEditors: yejinliang
 * @Description: 动态引入themes文件夹下三维全部模板
 */

const modulesFiles = require.context('./themes', true, /.js$/)

const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

export default modules